import { CALL_API } from './../../middlewares/api';

const onLoadListaSolicitacoes = () => ({
  [CALL_API]: {
    type: 'LIST_SOLICITACOES_AGUA_MINERAL',
    endpoint: 'agua-mineral',
    authenticated: true,
    config: {
      method: 'GET'
    }
  }
});

const onLoadConsumoAguaMineralPorCompetenciaIfNeeded = () => ({
  [CALL_API]: {
    type: 'LIST_SOLICITACOES_AGUA_MINERAL_COMPETENCIA',
    endpoint: 'agua-mineral',
    authenticated: true,
    config: {
      method: 'GET',
      querystring: { type: 'competencia' }
    }
  }
});

const onLoadConsumoAguaMineralPorCompetencia = () => (dispatch, getState) => {
  let { fetching, errors = [] } = getState().consumo.competencias;

  if (!fetching && !errors.length) {
    return dispatch(onLoadConsumoAguaMineralPorCompetenciaIfNeeded());
  }

  return Promise.resolve();
};

const onLoadConsumoAguaMineralDetalhePorCompetenciaIfNeeded = value => ({
  [CALL_API]: {
    type: 'LIST_DETALHE_SOLICITACOES_AGUA_MINERAL_COMPETENCIA',
    endpoint: 'agua-mineral',
    authenticated: true,
    config: {
      method: 'GET',
      querystring: { type: 'detalhe-competencia', competencia: value.competencia }
    }
  },
  value
});

const onLoadConsumoAguaMineralDetalhePorCompetencia = value => dispatch => {
  let { fetching, errors = [] } = value.detail || {};

  if (!fetching && !errors.length) {
    return dispatch(onLoadConsumoAguaMineralDetalhePorCompetenciaIfNeeded(value));
  }
  return Promise.resolve();
};

const onChangeSituacaoSolicitacaoAguaMineral = (type, value) => ({
  [CALL_API]: {
    type: 'CHANGE_SITUACAO_SOLICITACAO_AGUA_MINERAL',
    endpoint: 'agua-mineral',
    authenticated: true,
    config: {
      method: 'PUT',
      querystring: { id_solicitacao: value.id, type },
      body: { id_contratante: value.id_contratante }
    }
  },
  value
});

export default {
  onChangeSituacaoSolicitacaoAguaMineral,
  onLoadListaSolicitacoes,
  onLoadConsumoAguaMineralPorCompetencia,
  onLoadConsumoAguaMineralPorCompetenciaIfNeeded,
  onLoadConsumoAguaMineralDetalhePorCompetencia
};


// WEBPACK FOOTER //
// ./src/modules/aguaMineral/actions.js